<template>
    <div class="xml-upload-request">
        <section class="section">
            <b-loading is-full-page :active="isLoading"></b-loading>
            <b-notification v-if="error" type="is-danger is-light" aria-close-label="Close notification" role="alert">{{ error }}</b-notification>

            <template v-if="request">
                <h1 class="title">XML upload request #{{ request.id }}</h1>
                <upload-request-info :upload-request="request"/>
            </template>
        </section>
    </div>
</template>

<script>
import api from "@/api/api";
import 'vue-json-pretty/lib/styles.css';
import UploadRequestInfo from "@/components/UploadRequestInfo.vue";

export default {
    name: "XmlUploadRequest",
    components: {
        UploadRequestInfo,
    },
    props: {
        id: [String, Number],
    },
    data() {
        return {
            isLoading: false,
            request: null,
            error: null,
        }
    },
    methods: {
        async fetchData() {
            try {
                this.request = await api.xmlRequests.fetch(this.id);
            } catch (e) {
                this.error = e;
            }
        },
    },
    async created() {
        this.isLoading = true;
        await this.fetchData();
        this.isLoading = false;
    }
}
</script>

<style lang="scss" scoped>

</style>